import { useState } from 'react';
import { toast } from 'react-toastify';
import useModal from '../../../useModal';
import UseContext from '../../../../../hooks/useContext';
import Modalheader from '../../../components/header';
import ModalBody from '../../../components/body';
import ModalFooter from '../../../components/footer';
import Button from '../../../../button';
import StyledInput from '../../../../styledInput/StyledInput';
import ApiDatabase from '../../../../../server';

const ModalReactivateAdminMember = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const token = localStorage.getItem('xsrfToken');
  const [isLoading, setIsLoading] = useState(false);
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');

  const member = modalData || {};

  const handleConfirm = () => {
    if (!firstname.trim() || !lastname.trim() || !email.trim()) {
      toast.error('Veuillez remplir tous les champs');
      return;
    }

    setIsLoading(true);
    ApiDatabase.reactivateAdminTeamMember(
      { token, id_user: member._id, firstname, lastname, email },
      () => {
        setIsLoading(false);
        toast.success('Les accès ont été réactivés.');
        setModalDataReturn({ action: 'admin_member_reactivated', id_user: member._id });
        toggle();
      },
      (err) => {
        setIsLoading(false);
        toast.error(err.response?.data?.error || 'Erreur lors de la réactivation');
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Réactiver les accès
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-4 text-sm">
          <p className="text-gray-700">
            Veuillez saisir les informations de <strong>{member.firstname} {member.lastname}</strong> pour réactiver ses accès :
          </p>
          
          <div className="flex flex-col gap-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Prénom</label>
              <StyledInput
                type="text"
                placeholder="Prénom"
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)}
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Nom</label>
              <StyledInput
                type="text"
                placeholder="Nom"
                value={lastname}
                onChange={(e) => setLastname(e.target.value)}
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <StyledInput
                type="email"
                placeholder="email@exemple.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button onClick={toggle} size="LG" color="SECONDARY">
          Annuler
        </Button>
        <Button
          onClick={handleConfirm}
          size="LG"
          color="PRIMARY"
          disabled={isLoading || !firstname.trim() || !lastname.trim() || !email.trim()}
        >
          {isLoading ? 'Réactivation...' : 'Confirmer la réactivation'}
        </Button>
      </ModalFooter>
    </>
  );
};

export default ModalReactivateAdminMember;
